"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const EmailBase_1 = require("./EmailBase");
const auth_1 = require("../auth");
let TransactionalEmail = class TransactionalEmail extends EmailBase_1.EmailBase {
};
tslib_1.__decorate([
    type_graphql_1.Field(() => auth_1.User),
    typeorm_1.ManyToOne(() => auth_1.User, {
        cascade: true,
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], TransactionalEmail.prototype, "targetUser", void 0);
TransactionalEmail = tslib_1.__decorate([
    type_graphql_1.ObjectType(),
    typeorm_1.Entity()
], TransactionalEmail);
exports.TransactionalEmail = TransactionalEmail;
class TransactionalEmailEntity extends TransactionalEmail {
    toString() {
        return `Transactional email #${this.id}`;
    }
}
exports.TransactionalEmailEntity = TransactionalEmailEntity;
//# sourceMappingURL=TransactionalEmail.js.map